import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalMenuService {
  public pageTitle = new BehaviorSubject<string>('Welcome');
}
